import { React } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import './App.css';

import Login from "./pages/Login";
import { MainPageLayout } from "./pages/MainPageLayout";
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import SSOService from "./services/SSOService";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import ErrorPage from './pages/ErrorPage';

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
export default function App() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const [email, setEmail] = useState("");

  useEffect(() => {
    setEmail(account?.username || "")
  }, [account])

  useEffect(() => {
    instance.ssoSilent(loginRequest)
      .then(response => {
        console.log("SSO Silent Success:", response);

        const account = response.account;
        instance.setActiveAccount(account);

        const email = account.username || ""; // Lấy email người dùng
        setEmail(email); // Cập nhật email vào state
      })
      .catch(error => {
        console.log("SSO Silent Fail:", error);
        if (error instanceof InteractionRequiredAuthError) {
          console.log("SSO cần đăng nhập lại.");
        }
      });
  }, [instance]); // Chạy một lần khi instance khởi tạo

  return (
    <div className="App">
      <AuthenticatedTemplate>
        {email.includes("@sv1") ?
          <ErrorPage message="You are not logged in with a lecturer account. Please log in using a lecturer account to access the system!" />
          :
          <MainPageLayout />
        }
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
}
